<template>
  <div>
    <div class="d-flex align-center">
      <v-switch v-model="admin" @change="fetchData"></v-switch>
      <div>Vai trò: {{ admin ? 'Admin' : 'Phụ huynh' }}</div>
    </div>
    <v-row v-if="loaded">
      <v-col v-for="userCourse in displayCourses" :key="userCourse.id" cols="12" md="4">
        <v-card height="100%" outlined class="px-4">
          <v-row>
            <v-col cols="12" md="3">
              <v-progress-circular
                style="width: 50px"
                :rotate="-90"
                :size="100"
                :width="15"
                :value="userCourse | _get('dataDetails.progress', 0)"
                :color="userCourse | _get('dataDetails.progress', 0) | getProgressColor"
              >
                {{ userCourse | _get('dataDetails.progress', 0) }}%
              </v-progress-circular>
            </v-col>
            <v-col cols="12" md="9" class="d-flex flex-column justify-center">
              <div class="font-weight-bold">
                {{ userCourse | _get('course.title') }}
              </div>
              <div>
                <span class="text-caption text--secondary"> Vào học lần cuối: </span>
                <span class="font-weight-regular">
                  {{ userCourse | _get('dataDetails.lastCourseAccess') }}
                </span>
              </div>
              <div>
                <span class="text-caption text--secondary"> Điểm BTVN gần nhất: </span>
                <span class="font-weight-regular">
                  {{ userCourse | _get('lastHomeworkMark') }}
                </span>
              </div>
              <div>
                <span class="text-caption text--secondary"> Điểm bài kiểm tra gần nhất: </span>
                <span class="font-weight-regular" :style="{ color: getMarkColor(userCourse.submission) }">
                  {{ userCourse | _get('submission.lastMark') }}
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col v-if="totalItems > displayCourses.length" cols="12" md="4">
        <v-card class="d-flex align-center justify-center" height="100%" style="min-height: 100px" outlined>
          <span @click="load" style="cursor: pointer; color: #0d47a1"> XEM THÊM </span>
        </v-card>
      </v-col>
      <v-col cols="12">
        <div v-if="loadingMore">
          <v-skeleton-loader type="card-avatar, article"></v-skeleton-loader>
        </div>
      </v-col>
    </v-row>
    <div v-else>
      <v-skeleton-loader type="card-avatar, article, card"></v-skeleton-loader>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  components: {},
  props: {
    student: Object,
  },
  data() {
    return {
      loaded: false,
      loadingMore: false,
      admin: true,
    }
  },
  async created() {},
  computed: {
    ...mapState('OnlineStudy', ['userCourses', 'totalItems', 'displayCourses']),
  },
  methods: {
    ...mapActions('OnlineStudy', ['loadMore', 'getUserCourses']),
    async fetchData() {
      this.loaded = false
      await this.getUserCourses({ student: this.student, role: this.admin ? 'admin' : 'parent' })
      this.loaded = true
    },
    getMarkColor(submission) {
      const mark = this.$options.filters.getLastMark(submission)
      if (mark) {
        if (mark >= 0 && mark < 5) return 'red'
        if (mark >= 5 && mark < 9) return '#FB8C00'
        if (mark >= 9 && mark <= 10) return 'success'
      }

      return 'black'
    },
    async load() {
      this.loadingMore = true
      await this.loadMore()
      this.loadingMore = false
    },
  },
  watch: {
    student: {
      handler: 'fetchData',
      immediate: true,
    },
  },
  filters: {
    getProgressColor(progress) {
      if (progress >= 0 && progress < 50) return 'orange'
      if (progress >= 50 && progress < 100) return 'primary'
      if (progress === 100 || progress === '100') return '#46BE8A'
      return 'gray'
    },
    getLastMark(submission) {
      if (submission) {
        let mark = (submission.correct / submission.total) * 10
        return Math.round(mark * 100) / 100
      }
      return ''
    },
    getLastAccess(views) {
      if (views && views.length) {
        let lastTimeAccess = views[views.length - 1].updatedAt
        return moment(lastTimeAccess).fromNow()
      }
      return ''
    },
  },
}
</script>
<style scoped lang="scss"></style>
